import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  background: transparent;\n  display: flex;\n  padding: 16px 24px;\n  /* border-bottom: 1px solid ",
        "; */\n\n  ",
        " {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  flex: 1;\n  font-size: 16px;\n  font-weight: 700;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  flex-direction: column;\n  overflow-y: auto;\n  max-height: calc(90vh - ",
        "px);\n  ",
        " {\n    display: flex;\n    max-height: 90vh;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n  background: ",
        ";\n  box-shadow: 0px 20px 36px -8px rgba(14, 14, 44, 0.1), 0px 1px 1px rgba(0, 0, 0, 0.05);\n  /* border: 1px solid ",
        "; */\n  border-radius: 32px 32px 0px 0px;\n  width: 100%;\n  max-height: calc(var(--vh, 1vh) * 100);\n  z-index: ",
        ";\n  position: absolute;\n  min-width: ",
        ";\n  bottom: 0;\n  max-width: ",
        " !important;\n  /* min-height: 300px; */\n  margin-top: 0 !important;\n  ",
        " {\n    width: auto;\n    position: auto;\n    bottom: auto;\n    border-radius: 24px;\n    max-width: 100%;\n    max-height: 100vh;\n  }\n\n  &.connect-wallet-modal {\n    border: none;\n\n    .custom-border {\n      border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n    }\n\n    .btn-learn {\n      background: #f7686e;\n      color: #ffffff;\n    }\n\n    .icon-close {\n      width: 24px;\n    }\n  }\n\n  &.modal-unsp-network {\n    border: none;\n\n    h2 {\n      font-size: 18px;\n    }\n\n    /* .modal-header {\n      padding: 16px 24px;\n\n      background: #f7686e;\n      border-radius: 24px 24px 0px 0px;\n\n      border: none;\n    } */\n\n    .wrapper-warning {\n      display: flex;\n      padding: 16px;\n      align-items: center;\n      gap: 8px;\n      align-self: stretch;\n\n      border-radius: 12px;\n      border: 1px solid #ffa722;\n      background: rgba(255, 167, 34, 0.1);\n\n      div {\n        color: #ffa722;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 140%; /* 19.6px */\n      }\n    }\n\n    .switch-btn {\n      background: #f7686e;\n      color: #ffffff;\n\n      font-size: 14px;\n    }\n\n    .dc-btn {\n      border-color: #f7686e;\n      color: #f7686e;\n\n      font-size: 14px;\n    }\n  }\n\n  &#predictions-risk-disclaimer {\n    border: none;\n  }\n\n  &.modal-winning {\n    border: none;\n\n    .modal-header {\n      padding: 16px 24px;\n\n      background: ",
        ";\n      border-radius: 24px 24px 0px 0px;\n\n      border: none;\n    }\n  }\n\n  &.modal-welcome {\n    input {\n      box-sizing: content-box;\n      width: 14px;\n      height: 14px;\n      margin: 10px;\n      border-radius: 4px;\n      background: transparent;\n      border: 1px solid ",
        ";\n\n      &:checked {\n        background: ",
        ";\n      }\n    }\n\n    .checked:after {\n      color: #060303;\n      border-color: #060303;\n    }\n  }\n\n  &.oracle-chart-modal {\n    border: none;\n  }\n\n  &.trading-view-modal {\n    border: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Flex from "../../components/Box/Flex";
import { MotionBox } from "../../components/Box";
import { ArrowBackIcon, CloseIcon } from "../../components/Svg";
import { IconButton } from "../../components/Button";
export var mobileFooterHeight = 73;
export var ModalHeader = styled.div.withConfig({
    componentId: "sc-75278a96-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var background = param.background;
    return background || "transparent";
});
export var ModalTitle = styled(Flex).withConfig({
    componentId: "sc-75278a96-1"
})(_templateObject1());
export var ModalBody = styled(Flex).withConfig({
    componentId: "sc-75278a96-2"
})(_templateObject2(), mobileFooterHeight, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
export var ModalCloseButton = function(_param) {
    var onDismiss = _param.onDismiss, props = _object_without_properties(_param, [
        "onDismiss"
    ]);
    return /*#__PURE__*/ _jsx(CloseIcon, _object_spread({
        className: "icon-close",
        onClick: onDismiss,
        style: {
            cursor: "pointer"
        }
    }, props));
};
export var ModalBackButton = function(param) {
    var onBack = param.onBack;
    return /*#__PURE__*/ _jsx(IconButton, {
        variant: "text",
        onClick: onBack,
        "area-label": "go back",
        mr: "8px",
        children: /*#__PURE__*/ _jsx(ArrowBackIcon, {
            color: "primary"
        })
    });
};
export var ModalContainer = styled(MotionBox).withConfig({
    componentId: "sc-75278a96-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.modal.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.zIndices.modal;
}, function(param) {
    var $minWidth = param.$minWidth;
    return $minWidth;
}, function(param) {
    var $maxWidth = param.$maxWidth;
    return $maxWidth || "none";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white10;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
